import React from 'react';

export default function Spinner() {
  return (
    <div className="flex items-center justify-center py-20">
      <div className="w-10 h-10 border-4 border-green-100 border-t-green-600 rounded-full animate-spin" />
    </div>
  );
}